<template>
	<v-img
        :src="require('@/assets/logo.png')"
        min-height="100px"
        max-height="250px"
    />
  <v-app-bar
    v-scroll="onScroll"
    :color="isTransparent ? 'transparent' : '#F5F5F5'"
    flat
    style="height:300px"
  >
    <v-spacer />
    
    <v-spacer />
    <SocialMedia />
  </v-app-bar>
</template> 

<script>
export default {
  components: {
    SocialMedia: () => import('@/components/SocialMedia')
  },

  data: () => ({
    isTransparent: true
  }),

  methods: {
    onScroll () {
      this.isTransparent = window.pageYOffset < 200
    }
  }
}
</script>
